export const endpoints = {
  UPLOAD_FILE: '/api/medias',
  MANAGE_FILE: '/api/medias/:id',
};
